const SoulData = [
    {
        'key': 0,
        'name': 'Hero',
        'desc': "A human who fused with Gig in order to slay the World Eaters. As the hero, you want to use Gig's power to save the world. But use too much, and Gig will dominate your body and wreak havoc once more...",
        'img': './img/soul-char/hero.png',
        'head': './img/soul-char/hero-head.png'
    },
    {
        'key': 1,
        'name': 'Gig',
        'desc': "Leader of the World Eaters that nearly destroyed the world 200 years ago. He has powers beyond the wildest dreams of any mortal. He is feared by all as the Master of Death and God of Destruction. He was nearly killed by Layna, who sealed his soul in an onyx blade. Eventually, he fused with the hero, thanks to the oddly vital Layna. He's cocky and smug, and all he wants is a physical form of his own.",
        'img': './img/soul-char/gig.png',
        'head': './img/soul-char/gig-head.png'
    },
    {
        'key': 2,
        'name': 'Danette',
        'desc': "A Sepp girl who has lived with the hero under Layna's protection since the age of 7. She has a tough time remembering names, and hates putting too much effort into thinking about anything. She's direct and thinks the best of people. ",
        'img': './img/soul-char/danette.png',
        'head': './img/soul-char/danette-head.png'
    },
    {
        'key': 3,
        'name': 'Layna the Firebrand',
        'desc': "The greatest mage of all time whose name was known across the land over 200 years ago. She was thought to have been killed by Gig, but she's lived in secrecy for 200 years. She founded a village to search for the one who could control Gig. She's a mysterious woman who has lived far longer than any human should. ",
        'img': './img/soul-char/layna.png',
        'head': './img/soul-char/layna-head.png'
    },
    {
        'key': 4,
        'name': 'Levin',
        'desc': "A young Sepp gatekeeper in Astec. He also works for Christophe, leader of the city's merchant guild. His only weapons are his quick feet and solid fists. He never thinks before he acts, and he's a horrible liar. He takes care of his sick older sister, and refuses to leave her side. ",
        'img': './img/soul-char/levin.png',
        'head': './img/soul-char/levin-head.png'
    },
    {
        'key': 5,
        'name': 'Vitali',
        'desc': "Works under Christophe in Astec, just like Levin. He's an eerily silent and sneaky man. He excels in stealth and spy missions. If it weren't for the awful state of the world, he'd be a gourmet chef. Though normally quiet, he can talk for hours about exotic foods.",
        'img': './img/soul-char/vitali.png',
        'head': './img/soul-char/vitali-head.png'
    }
]

export default SoulData;